<template>
	<div data-v-a6a2afe4 class="ui-tabbar-wrapper">
		<div data-v-a6a2afe4 class="tabbar-wrapper">
			<ul data-v-a6a2afe4>
				<li data-v-a6a2afe4
					class="item"
					v-for="item in staticData"
					v-bind:key="item.key"
					v-on:click="setCurrentActive(item)"
					v-bind:class="{ currentavtive: currentItem == item.link }"
				>
					<img data-v-a6a2afe4 v-bind:src="item.bgurl" v-if="currentItem != item.link" />
					<img data-v-a6a2afe4 v-bind:src="item.activeBgurl" v-if="currentItem == item.link" />
					<span data-v-a6a2afe4 v-if="cartNumber > 0 && item.link == 'cart' && isOnline">{{
						getCarCount
					}}</span>
					<p data-v-a6a2afe4 v-if="item.name == $t('tabBar.t4') && isHasUnreadCount"></p>
					<a data-v-a6a2afe4>{{ item.name }}</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
	data() {
		return {
			staticData: [
				{
					name: this.$t('tabBar.t1'),
					link: 'home',
					key: 0,
					bgurl: require('../../assets/image/tabbar-icon/tabbar_home_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_home_sel@2x.png'),
					isActive: true
				},
				{
					name: this.$t('tabBar.t2'),
					link: 'mall',
					key: 1,
					bgurl: require('../../assets/image/tabbar-icon/tabbar_cart_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_cart_sel@2x.png'),
					isActive: false
				},
				{
					name: this.$t('tabBar.t3'),
					link: 'income',
					params: { type: 1 },
					key: 2,
					bgurl: require('../../assets/image/tabbar-icon/tabbar_income_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_income_sel@2x.png'),
					isActive: false
				},
				{
					name: this.$t('tabBar.t4'),
					link: 'my',
					key: 3,
					bgurl: require('../../assets/image/tabbar-icon/tabbar_profile_nor@2x.png'),
					activeBgurl: require('../../assets/image/tabbar-icon/tabbar_profile_sel@2x.png'),
					isActive: false
				}
			],
			currentItem: this.$store.state.tabBar.currentTabBar
				? this.$store.state.tabBar.currentTabBar
				: 'home'
		}
	},

	computed: {
		...mapState({
			currentTabBar: state => state.tabBar.currentTabBar,
			cartNumber: state => state.tabBar.cartNumber,
			isOnline: state => state.auth.isOnline,
			messageHint: state => state.tabBar.messageHint
		}),
		...mapGetters({
			isHasUnreadCount: 'isHasUnreadCount'
		}),
		getCarCount() {
			if (this.cartNumber > 0 && this.cartNumber < 100) {
				return this.cartNumber
			} else if (this.cartNumber >= 100) {
				return '99+'
			}
		}
	},

	watch: {
		currentTabBar: function(value) {
			let data = this.staticData
			for (let i = 0; i <= data.length - 1; i++) {
				if (value == data[i].link) {
					this.currentItem = data[i].link
				}
			}
			if (value !== 'category') {
				this.resetCurrentCategoryItem()
			}
		}
	},

	methods: {
		...mapMutations({
			resetCurrentCategoryItem: 'resetCurrentCategoryItem'
		}),
		gotoPage(path) {
			this.$router.push(path)
		},

		setCurrentActive(item) {
			this.currentItem = item.link
			this.$router.push({ name: item.link, params: item.params })
		}
	}
}
</script>

<style scoped></style>
